import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const ArrowsLeftRightBorderlessIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M1.5 17.25C1.5 17.6642 1.83579 18 2.25 18H19.9393L15.2197 22.7197C14.9268 23.0126 14.9268 23.4874 15.2197 23.7803C15.5126 24.0732 15.9874 24.0732 16.2803 23.7803L22.2803 17.7803C22.5732 17.4874 22.5732 17.0126 22.2803 16.7197L16.2803 10.7197C15.9874 10.4268 15.5126 10.4268 15.2197 10.7197C14.9268 11.0126 14.9268 11.4874 15.2197 11.7803L19.9393 16.5H2.25C1.83579 16.5 1.5 16.8358 1.5 17.25Z",
    fill: color
  }), __jsx("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M22.5 6.75C22.5 7.16421 22.1642 7.5 21.75 7.5L4.06066 7.5L8.78033 12.2197C9.07322 12.5126 9.07322 12.9874 8.78033 13.2803C8.48744 13.5732 8.01256 13.5732 7.71967 13.2803L1.71967 7.28033C1.42678 6.98744 1.42678 6.51256 1.71967 6.21967L7.71967 0.21967C8.01256 -0.0732233 8.48744 -0.0732233 8.78033 0.21967C9.07322 0.512563 9.07322 0.987438 8.78033 1.28033L4.06066 6L21.75 6C22.1642 6 22.5 6.33579 22.5 6.75Z",
    fill: color
  }));
};
export default ArrowsLeftRightBorderlessIcon;